import React from 'react';
import { PageHero } from '../components/ui/PageHero';
import { FAQSection } from '../components/sections/FAQSection';
import { EmergencyCTA } from '../components/sections/EmergencyCTA';
export function FAQ() {
  return <>
      <PageHero eyebrow="FAQ" title="Frequently Asked Questions" subtitle="Clear answers about our services, process, insurance, and response times." crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'FAQ'
    }]} data-id="element-455" data-mp="376gkpkkk05nd" />
      <FAQSection data-id="element-456" data-mp="3b5fxtsgfv8pw" />
      <EmergencyCTA data-id="element-457" data-mp="3pvwxp7dfdqko" />
    </>;
}